import React from 'react';
import shallowEqual from 'fbjs/lib/shallowEqual';

function withShallowComparison(WrappedComponent, propsToExclude) {

  return class extends React.Component {
    shouldComponentUpdate(nextProps) {
      let propsCopy = {...this.props};
      let nextPropsCopy = {...nextProps};
      for (const exclusion of propsToExclude) {
        propsCopy = {...propsCopy, [exclusion]: null};
        nextPropsCopy = {...nextPropsCopy, [exclusion]: null};
      }
      return !shallowEqual(propsCopy, nextPropsCopy);
    }

    render() {
      return <WrappedComponent
        { ...this.props }
      />;
    }
  };
}

export default withShallowComparison;